import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "./config";

// Create a secondary Firebase app instance for creating users without logging out the admin
const secondaryApp = initializeApp(
  {
    apiKey: "AIzaSyCEc3tYojH94votJ0VEdvnww-f-2QSf-Vk",
    authDomain: "my-neighbor-2f144.firebaseapp.com",
    projectId: "my-neighbor-2f144",
    storageBucket: "my-neighbor-2f144.firebasestorage.app",
    messagingSenderId: "215490249660",
    appId: "1:215490249660:web:7366fcf79988ecdd5221b9",
    measurementId: "G-3VF7EMZMQ6",
  },
  "Secondary" // Named instance
);

const secondaryAuth = getAuth(secondaryApp);

export const createNewUser = async (userData) => {
  try {
    // Create user with secondary auth instance to avoid logging out the admin
    const userCredential = await createUserWithEmailAndPassword(
      secondaryAuth,
      userData.email,
      userData.password
    );

    const user = userCredential.user;

    // Create user document in Firestore
    await setDoc(doc(db, "users", user.uid), {
      email: userData.email,
      name: userData.name,
      idNumber: userData.idNumber || "",
      address: userData.address || "",
      neighborhoodDollars: Number(userData.neighborhoodDollars) || 1000,
      isAdmin: userData.isAdmin || false,
      createdAt: new Date(),
      friends: [],
    });

    // Sign out the newly created user from the secondary auth instance
    // This ensures they don't stay logged in on this secondary instance
    await signOut(secondaryAuth);

    return user;
  } catch (error) {
    console.error("Error creating new user:", error);
    throw error;
  }
};
